import { forwardRef, memo } from 'react';
import type { StepFormApi } from '@/hooks/useStepValidation';
import type { ScheduleStepProps } from '../../schedule.types';
import { ScorecardStep as SharedScorecardStep } from '../../../components/ScorecardStep';
import { SCHEDULE_INTERVIEW_COPY } from '../../schedule.copy';

export const ScorecardStep = memo(
  forwardRef<StepFormApi, ScheduleStepProps>((props, ref) => (
    <SharedScorecardStep
      ref={ref}
      payloadRef={props.payloadRef}
      prefillVersion={props.prefillVersion}
      copy={SCHEDULE_INTERVIEW_COPY.scorecard}
    />
  ))
);

ScorecardStep.displayName = 'ScorecardStep';
